import { jsxs as i, jsx as m } from "react/jsx-runtime";
import { makeClassesByStyles as n } from "../../../../../utils/classes.js";
import s from "../../../../../assets/110af573.spinner-image.module.css";
const e = n(s), l = ({ imageUrl: r, className: a }) => /* @__PURE__ */ i("div", { className: e(s.SpinnerImage, a), children: [
  /* @__PURE__ */ m("div", { className: e(s.spinner) }),
  /* @__PURE__ */ m("img", { src: r, className: e(s.image) })
] });
export {
  l as SpinnerImage
};
